<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="设备编号"
                prop="deviceCode"
              >
                <a-input
                  v-model="queryParam.deviceCode"
                  placeholder="请输入设备编号"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="所属管线"
                prop="pipelineId"
              >
                <a-select
                  v-model="queryParam.pipelineId"
                  placeholder="请选择所属管线"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in pipelineList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.pipelineName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="设备类型"
                prop="deviceTypeId"
              >
                <a-select
                  v-model="queryParam.deviceTypeId"
                  placeholder="请选择设备类型"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in deviceTypeList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="风险等级"
                prop="riskLevel"
              >
                <a-select
                  v-model="queryParam.riskLevel"
                  placeholder="请选择风险等级"
                  allow-clear
                >
                  <a-select-option
                    :key="1"
                    :value="1"
                  >高</a-select-option>
                  <a-select-option
                    :key="2"
                    :value="2"
                  >中</a-select-option>
                  <a-select-option
                    :key="3"
                    :value="3"
                  >低</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="保护状态"
                prop="protectionStatus"
              >
                <a-select
                  v-model="queryParam.protectionStatus"
                  placeholder="请选择保护状态"
                  allow-clear
                >
                  <!--                  <a-select-option :key="0" :value="0">正常保护</a-select-option>-->
                  <a-select-option
                    :key="1"
                    :value="1"
                  >欠保护</a-select-option>
                  <a-select-option
                    :key="2"
                    :value="2"
                  >过保护</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="分析时间"
                prop="analyseTime"
              >
                <a-space
                  direction="vertical"
                  :size="12"
                >
                  <a-range-picker
                    style="width: 100%"
                    v-model="dateRange"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear
                  />
                </a-space>
              </a-form-item>
            </a-col>
            <a-col
              :md="!advanced && 6 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}"
              >
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
                <a
                  @click="toggleAdvanced"
                  style="margin-left: 8px"
                >
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 4350, y: 3000 }"
      >
        <span
          slot="index"
          slot-scope="text, record, index"
        >
          {{ ((queryParam.pageNum - 1) * queryParam.pageSize) + (index + 1) }}
        </span>
        <span
          slot="riskLevel"
          slot-scope="text, record"
        >
          <a-tag
            v-if="record.riskLevel == 1"
            color="#f50"
          >高</a-tag>
          <a-tag
            v-if="record.riskLevel == 2"
            color="#2db7f5"
          >中</a-tag>
          <a-tag
            v-if="record.riskLevel == 3"
            color="#87d068"
          >低</a-tag>
        </span>
        <span
          slot="protectionStatus"
          slot-scope="text, record"
        >
          <a-tag
            v-if="record.protectionStatus == 0"
            color="#87d068"
          >正常</a-tag>
          <a-tag
            v-if="record.protectionStatus == 1"
            color="#2db7f5"
          >欠保护</a-tag>
          <a-tag
            v-if="record.protectionStatus == 2"
            color="#108ee9"
          >过保护</a-tag>
        </span>
        <span
          slot="analyseTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.analyseTime) }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDeviceEvaluate, listPipeline, listDeviceType } from '@/api/saifuneng/deviceevaluate'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DeviceEvaluate',
  components: {

  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pipelineList: [],
      deviceTypeList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParam: {
        deviceCode: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pipelineId: undefined,
        deviceId: undefined,
        deviceTypeId: undefined,
        riskLevel: undefined,
        protectionStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          ellipsis: true,
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '管线名称',
          dataIndex: 'pipelineName',
          ellipsis: true,
          align: 'center',
          width: 250,
          fixed: 'left'
        },
        {
          title: '位置编号',
          dataIndex: 'locationDescription',
          ellipsis: true,
          align: 'center',
          width: 250,
          fixed: 'left'
        },
        {
          title: '阴保类型',
          dataIndex: 'deviceTypeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '阴保状态',
          dataIndex: 'protectionStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'protectionStatus' }
        },
        {
          title: '风险等级',
          dataIndex: 'riskLevel',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'riskLevel' }
        },
        {
          title: '故障或风险描述',
          dataIndex: 'faultOrRiskDescription',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '诊断标准',
          dataIndex: 'diagnosticCriteria',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '建议采取措施',
          dataIndex: 'recommendedMeasure',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '分析时间',
          dataIndex: 'analyseTime',
          scopedSlots: { customRender: 'analyseTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备编号',
          dataIndex: 'deviceCode',
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getPipelineList()
    this.getDeviceTypeList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询设备信息列表 */
    getList () {
      this.loading = true
      if (this.dateRange !== null && this.dateRange !== '' && this.dateRange.length === 2) {
        this.queryParam.createBeginTime = this.dateRange[0] + " 00:00:00"
        this.queryParam.createEndTime = this.dateRange[1] + " 23:59:59"
      }
      pageDeviceEvaluate(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        deviceCode: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pipelineId: undefined,
        deviceId: undefined,
        deviceTypeId: undefined,
        riskLevel: undefined,
        protectionStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getPipelineList () {
      listPipeline().then(response => {
        this.pipelineList = response.data
      })
    },
    getDeviceTypeList () {
      listDeviceType().then(response => {
        this.deviceTypeList = response.data
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }

  }
}
</script>
